import { MutationTree } from 'vuex';
import Vue from 'vue';

const mutations: MutationTree<Store.Events.State> = {
  setEvent(state, payload: Store.Events.Event) {
    Vue.set(state, 'event', payload);
  },
  setSecret(state, payload: string) {
    Vue.set(state, 'secret', payload);
  },
  setEvents(state, payload: Store.Events.Event[]) {
    Vue.set(state, 'events', payload);
  },
  setTotal(state, total: number) {
    state.total = total;
  },
  addEvent(state, payload: Store.Events.Event) {
    state.events.push(payload);
    state.total += 1;
  },
  removeEvents(state, ids: number[]) {
    const filteredEvents = state.events
      .filter((event) => !ids.includes(event.id));
    state.total -= ids.length;
    Vue.set(state, 'events', filteredEvents);
    console.log('filteredEvents => ', filteredEvents);
    // for (let i = 0; i < ids.length; i += 1) {
    //   state.events = state.events.filter((event) => event.id !== ids[i]);
    //   state.total -= 1;
    // }
  },
  changeEventStatus(state, payload: Services.Events.StartOrEndLive) {
    Vue.set(state, 'event', {
      ...state.event,
      status: payload.status,
    });
  },
  editEvent(state, payload: Services.Events.PutEvent) {
    const updatedEvents = state.events.map((event) => {
      if (event.id === payload.eventId) {
        return {
          ...event,
          ...payload,
        };
      }

      return event;
    });

    Vue.set(state, 'events', updatedEvents);
  },
};

export default mutations;
